import { render, staticRenderFns } from "./source.vue?vue&type=template&id=3d8612ab&scoped=true&"
import script from "./source.vue?vue&type=script&lang=ts&"
export * from "./source.vue?vue&type=script&lang=ts&"
import style0 from "./source.vue?vue&type=style&index=0&id=3d8612ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8612ab",
  null
  
)

export default component.exports